import { AreWillingToChange } from "./steps/AreWillingToChange";
import BirthGender from "./steps/BirthGender";
import { BloodPressure } from "./steps/BloodPressure";
import { CurrentMedications } from "./steps/CurrentMedications";
import { CurrentWeight } from "./steps/CurrentWeight";
import { DiabetesDiagnosis } from "./steps/DiabetesDiagnosis";
import { Diagnoses } from "./steps/Diagnoses";
import { FurtherNotes } from "./steps/FurtherNotes";
import { HeartRate } from "./steps/HeartRate";
import { HeightWeight } from "./steps/HeightWeight";
import { LastDoseWeightLossMeds } from "./steps/LastDoseWeightLossMeds";
import { MedicalHistory } from "./steps/MedicalHistory";
import { MedicationAllergies } from "./steps/MedicationAllergies";
import { OpiateMedications } from "./steps/OpiateMedications";
import { Pharmacy } from "./steps/Pharmacy";
import { PreviousWLAttempts } from "./steps/PreviousWLAttempts";
import { PriorBariatricSurgery } from "./steps/PriorBariatricSurgery";
import { StartingWeight } from "./steps/StartingWeight";
import { WeightBmiGoal } from "./steps/WeightBmiGoal";
import { WeightInLastYear } from "./steps/WeightInLastYear";
import { WeightLossGoal } from "./steps/WeightLossGoal";
import { WeightLossMedicationList } from "./steps/WeightLossMedicationList";
import { WeightLossMeds } from "./steps/WeightLossMeds";
import { WeightLossMedsInPast } from "./steps/WeightLossMedsInPast";
import { WeightLossMedsThroughUs } from "./steps/WeightLossMedsThroughUs";
import { Welcome } from "./steps/Welcome";

export const steps = [
  { component: Welcome, subSteps: [], name: "Welcome" },
  { component: WeightLossGoal, subSteps: [], name: "WeightLossGoal" },
  { component: HeightWeight, subSteps: [], name: "HeightWeight" },
  { component: BirthGender, subSteps: [], name: "BirthGender" },
  { component: Diagnoses, subSteps: [], name: "Diagnoses" },
  {
    component: WeightLossMeds,
    name: "WeightLossMeds",
    subSteps: [
      { component: WeightLossMedicationList, name: "WeightLossMedicationList" },
      { component: StartingWeight, name: "StartingWeight" },
      { component: CurrentWeight, name: "CurrentWeight" },
      { component: WeightLossMedsThroughUs, name: "WeightLossMedsThroughUs" },
      { component: LastDoseWeightLossMeds, name: "LastDoseWeightLossMeds" },
    ],
  },
  { component: CurrentMedications, subSteps: [], name: "CurrentMedications" },
  {
    component: WeightLossMedsInPast,
    subSteps: [],
    name: "WeightLossMedsInPast",
  },
  { component: OpiateMedications, subSteps: [], name: "OpiateMedications" },
  {
    component: PriorBariatricSurgery,
    subSteps: [],
    name: "PriorBariatricSurgery",
  },
  { component: PreviousWLAttempts, subSteps: [], name: "PreviousWLAttempts" },
  { component: AreWillingToChange, subSteps: [], name: "AreWillingToChange" },
  { component: WeightInLastYear, subSteps: [], name: "WeightInLastYear" },
  { component: MedicalHistory, subSteps: [], name: "MedicalHistory" },
  { component: DiabetesDiagnosis, subSteps: [], name: "DiabetesDiagnosis" },
  { component: BloodPressure, subSteps: [], name: "BloodPressure" },
  { component: HeartRate, subSteps: [], name: "HeartRate" },
  { component: WeightBmiGoal, subSteps: [], name: "WeightBmiGoal" },
  { component: FurtherNotes, subSteps: [], name: "FurtherNotes" },
  { component: MedicationAllergies, subSteps: [], name: "MedicationAllergies" },
  { component: Pharmacy, subSteps: [], name: "Pharmacy" },
];
